import {useState, useEffect} from 'react'

import useConfirmModalAtom from 'shared/model/useConfirmModalAtom'
import useFetch from 'shared/model/useFetch'

const usePostScanUserQR = (clearAndRescan) => {
	const [fetchResult, fetchRequest, isLoading] = useFetch()
	const [, setConfirm] = useConfirmModalAtom()
	const [scanResult, setScanResult] = useState(null)
	const [isBottomOpen, setIsBottomOpen] = useState(false)
	const [account_idx, setAccountIdx] = useState(null)
	const [serial_number, setSerialNumber] = useState(null)

	const request = (qrToken) => {
		fetchRequest('POST', `/admin/event/scan-user-qr`, {
			qr_token: qrToken,
		})
	}

	const clearScanResult = () => {
		setScanResult(null)
		setIsBottomOpen(false)
		setAccountIdx(null)
		setSerialNumber(null)
	}

	const handleRefetch = () => {
		fetchRequest('POST', `/admin/event/scan-user-qr`, {
			account_idx,
			...(serial_number && {serial_number}),
		})
	}

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 200:
				setAccountIdx(fetchResult?.data?.user_info?.idx)
				setScanResult(fetchResult?.data)

				const serialNumber =
					fetchResult?.data?.eligible_competitions[0]?.ticket_info
						?.serial_number
				if (serialNumber) {
					setSerialNumber(serialNumber)
				}
				setIsBottomOpen(true)
				break
			case 401:
				setConfirm(
					'QR 토큰이 만료되었거나 올바르지 않습니다. QR을 새로고침한 후 다시 시도해 주세요.',
					() => {
						return () => {
							clearAndRescan()
							clearScanResult()
						}
					},
					false
				)
				break
			case 400:
			case 404:
			case 500:
				setConfirm(
					'오류가 발생했습니다. 다시 시도해 주세요.',
					() => {
						return () => {
							clearAndRescan()
							clearScanResult()
						}
					},
					false
				)
				break
			case 403:
				setConfirm(
					'이 참가권은 귀하가 관리하는 대회가 아닙니다',
					() => {
						return () => {
							clearAndRescan()
							clearScanResult()
						}
					},
					false
				)
				break
			default:
				break
		}
	}, [fetchResult])

	return [
		request,
		scanResult,
		isLoading,
		clearScanResult,
		isBottomOpen,
		handleRefetch,
	]
}

export default usePostScanUserQR
